import { useDiagnosisFormat } from 'features/Procedure/hooks/useDiagnosisFormat'

type Props = {
  justifyCodes: string[]
  selectedEncounterUid?: string
  count: number
}

export const DiagnosticCell = ({ justifyCodes, selectedEncounterUid, count }: Props) => {
  const { diagnosisFormat } = useDiagnosisFormat({ justifyCodes, selectedEncounterUid })

  return (
    <div>
      {count} {diagnosisFormat.join(', ')}
    </div>
  )
}
